export const GET_DATA_SUPERVISOR = 'GET_DATA_SUPERVISOR';
export const RESET_LOADING = 'RESET_LOADING';
export const SUBMIT_FAILED = 'SUBMIT_FAILED';
export const SUBMIT_SUCCEED = 'SUBMIT_SUCCEED';
export const CLOSE_NEW_DIALOG = 'CLOSE_NEW_DIALOG';
export const OPEN_NEW_DIALOG = 'OPEN_NEW_DIALOG';
export const RESET_MESSAGE = 'RESET_MESSAGE';
export const FILTER_SUPERVISOR = 'FILTER_SUPERVISOR';
export const LOAD_SUPERVISOR_BY_FILTER = 'LOAD_SUPERVISOR_BY_FILTER';
export const EDIT_SUPERVISOR = 'EDIT_SUPERVISOR';
export const DELETE_SUPERVISOR = 'DELETE_SUPERVISOR';